import { useMemo } from 'react';
import { GetData } from './Data/GetData';
import FestivalComponent from './Components/FestivalComponent';
import './css/global.css';

function App() {
  const festivalData = useMemo(() => GetData(), []);
  return (
    <div className="App">
      <header className="App-header">
        <main>
          <FestivalComponent festival={festivalData} />
        </main>
      </header>
    </div>
  );
}

export default App;
